import { useTutorInvoicesStore } from '~common/store';

export const tutorInvoiceSelector = (state) => ({
  invoices: state.invoices,
  getTutorInvoices: state.getTutorInvoices,
});

export default useTutorInvoicesStore;
